import { BadgeCheck, User, CalendarDays, Clock } from "lucide-react";

export default function UserLeaveRequest({
  leaves,
  handleDeny,
  handleApprove,
}) {
  return (
    <div className="p-6">
      {/* Work Details Card */}
      <section className="bg-white mb-16">
        <h2 className="text-gray-800 font-semibold text-lg mb-4">
          Leave Requests
        </h2>
        <hr className="w-full mb-2 mt-2" />

        {leaves?.map((leave) => {
          const start = new Date(leave.startTime);
          const end = new Date(leave.endTime);

          const leaveType = leave.type;

          // Format date range: e.g. "Mon 13 May 2025 → Wed 15 May 2025"
          const formattedStart = start.toLocaleDateString("en-US", {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
          const formattedEnd = end.toLocaleDateString("en-US", {
            weekday: "short",
            day: "2-digit",
            month: "short",
            year: "numeric",
          });

          // Format duration in hours with one decimal place
          const durationHours = leave.duration
            ? leave.duration.toFixed(1)
            : "0";

          // Map status to badge colors (example)
          const statusColors = {
            pending: "bg-orange-100 text-orange-800",
            approved: "bg-green-100 text-green-800",
            rejected: "bg-red-100 text-red-800",
          };

          const badgeColor =
            statusColors[leave.status] || "bg-gray-100 text-gray-600";

          // Capitalize status text
          const statusText = leave.status
            ? leave.status.toUpperCase()
            : "UNKNOWN";

          return (
            <div
              key={leave._id}
              className="bg-gray-50 p-4 relative w-full mb-4 rounded shadow"
            >
              {/* Approve button - top right */}
              {!leave.approved && leave.status !== "rejected" && (
                <div className="absolute top-3 right-3 flex gap-2">
                  <button
                    onClick={() => handleApprove(leave._id)}
                    className="bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded"
                  >
                    Approve
                  </button>
                  <button
                    onClick={() => handleDeny(leave._id)} // Make sure to define handleReject
                    className="bg-red-500 hover:bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded"
                  >
                    Reject
                  </button>
                </div>
              )}

              <h3 className="text-gray-800 font-semibold mb-2">
                {leave.reason || "Leave Request"}{" "}
                <span className="text-sm text-gray-600">
                  ({durationHours} hours)
                </span>
              </h3>
              <p className="text-gray-700 text-sm mb-2">{leaveType}</p>
              <p className="text-gray-700 text-sm mb-2">
                {formattedStart} &rarr; {formattedEnd}
              </p>

              <div
                className={`absolute bottom-3 right-3 rounded-full px-3 py-1 text-xs font-semibold shadow-sm ${badgeColor}`}
              >
                {statusText}
              </div>
            </div>
          );
        })}
      </section>
    </div>
  );
}
